import axios from 'axios';
import * as types from './actionTypes';

export function getFlags(orgId) {
    return function (dispatch) {
        dispatch({ type: types.GET_FLAGS_PENDING });
        return axios
            .get(`${window.GENESIS_CMS_API_URL}/v2/organizations/${orgId}/features`)
            .then((response) => {
                // response.data.data.analytics = false;
                dispatch({
                    type: types.GET_FLAGS_SUCCESS,
                    payload: response.data.data,
                });
            })
            .catch((error) => {
                dispatch({
                    type: types.GET_FLAGS_FAILED,
                    payload: error,
                });
            });
    };
}
